<template>
    <div class="app-loading-widget" v-if="showScreen">
        <div class="blinking">
            <img class="pollux-logo" src="/assets/img/logos/pollux-default.svg">
            <div class="highlight">loading...</div>
        </div>
        <div class="network-fact"> 
            <div>
                <b>Did you know that: </b> 
                <div>{{ networkFact }}</div>
            </div>
         </div>
    </div>
</template>
<script lang="ts">
import { getRandomNetworkFact } from '@/utils/networkFacts';
import { onMounted, ref } from 'vue';

/**
 * Shows that the Pollux Application is loading and shows a nice network fact
 * whilst the user is waiting. Should not be used when waiting for content to be loaded.
 * For that you can use the status indicator.
 */
export default {
    setup() {
        const networkFact = ref("")
        const showScreen = ref(false)

        onMounted(() => {
            // get a nice network fact
            networkFact.value = getRandomNetworkFact()

            // only shows loading screen after 300ms
            setTimeout(() => {showScreen.value = true}, 300)
        })
        
        return {
            networkFact,
            showScreen,
        }
    }
}
</script>
<style lang="scss">
.app-loading-widget{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 64px;

    .blinking{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 16px;
        animation-name: grow-shrink;
        animation-duration: 2s;
        animation-iteration-count: infinite;

        .pollux-logo{
            width: 200px;
        }
    }

    .network-fact{
        display: flex;
        justify-content: center;
        position: absolute;
        bottom: 16px;
        left: 0px;
        width: 100vw;


        div{
            max-width: 400px;
            text-align: center;
            font-size: 11px;
        }
    }



    @keyframes grow-shrink {
        0%{
            transform: scale(1);
        }

        50%{
            transform: scale(1.1);
        }

        100%{
            transform: scale(1);
        }
    }
}


</style>